import makeStyles from '@mui/styles/makeStyles';
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { Loadable } from '../../../../../common';

import { FeeScheduleItemsView } from './FeeScheduleItems';

const useStyles = makeStyles(theme => {
    return {
        root: {
            color: '#48465b',
        },
        portlet: {
            'box-shadow': 'none',
            '& .kt-portlet__head': {
                paddingLeft: 0
            }
        },
    }
});

export default function FeeSchedule({ feeScheduleId, feeSchedule, feeSchedulePending,
    actions: { getFeeschedule,getHierarchy }
}) {
    const classes = useStyles();
    const location = useLocation();
    const isGlobal =  location.pathname.includes('global-feeschedules');

    useEffect(() => {
        getFeeschedule(feeScheduleId, null, isGlobal);
    }, [feeScheduleId,isGlobal]);

    useEffect(() => {
        getHierarchy(isGlobal)
    }, [isGlobal]);

    return (
        <Loadable loading={feeSchedulePending}>
            <FeeScheduleItemsView
                feeScheduleId={feeScheduleId}
                feeSchedule={feeSchedule}
                location={location}
            />
        </Loadable>
    );
}
